module.exports = __webpack_public_path__ + "img/mares-signature.b199c5d8.svg";